// frontend/src/Components/SyncTo/helpers/downloadBlob.js
// Phase 30 — D-04 / D-05 Blob→download helper. Analog: ExportReceiptPDF.jsx:377-392.
// Divergence from analog: 60s revoke delay (not 100ms) — audio blobs are larger
// than PDFs and the download dialog can take longer to resolve on some platforms.
// FILENAME CONTRACT: NO PHI identifiers (no patient name, label, or id). Filename lands on Downloads folder.

import { mimeToExt } from './mimePicker';

export function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
}

/**
 * buildDownloadFilename — returns `session-<short8>-<ISO>-safe.<ext>`.
 * sessionKey-short = first 8 chars of UUID
 * ISO-safe         = new Date().toISOString().replace(/[:.]/g, '-')   (Windows rejects ':')
 * ext              = mimeToExt(mimeType)
 *
 * CONTEXT.md §Specifics: PHI identifiers are NEVER in the filename.
 */
export function buildDownloadFilename(sessionKey, mimeType) {
  const short = String(sessionKey).slice(0, 8);
  const iso   = new Date().toISOString().replace(/[:.]/g, '-');
  const ext   = mimeToExt(mimeType);
  return `session-${short}-${iso}${ext}`;
}
